import { useNavigate } from 'react-router-dom';
import { RecipeArchive } from '../components/Cookbook/RecipeArchive';
import { usePageTitle } from '../hooks/usePageTitle';

export const RecipeArchivePage = () => {
  usePageTitle('Recipe Archive | Meals You Love');
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return <RecipeArchive onBack={handleBack} />;
};